import { memo } from 'react';
import {
  Button,
  CheckBox,
  List,
  ListItem,
  Status,
} from '@yaradigitallabs/ahua-react';
import { LoaderPlaceholder } from '@/components/Placeholder';
import type { SoftTag } from '../utils/match-maker.types';

export type SoftTagItemModel = SoftTag;

interface SoftTagListItemProps {
  item: SoftTag;
  checked?: boolean;
  disabled?: boolean;
  onCheckedChange?: (item: SoftTag, checked: boolean) => void;
  onDetailSelect?: (softTagId: string) => void;
}

const SoftTagListItemComponent = ({
  item,
  checked = false,
  disabled = false,
  onCheckedChange,
  onDetailSelect,
}: SoftTagListItemProps) => {
  return (
    <List.Middle className="overflow-y-visible!">
      <ListItem>
        <ListItem.BodyTail divider>
          <ListItem.Body css={{ paddingLeft: '8px' }}>
            <ListItem.Subtitle>{item.tag_name}</ListItem.Subtitle>
            <ListItem.Caption>{item.tag_description}</ListItem.Caption>
          </ListItem.Body>
          <ListItem.Tail>
            <div className="flex flex-row items-center gap-3">
              <Status colorType="gray">{item.type}</Status>
              <Button
                colorConcept="brand"
                size="s"
                variant="ghost"
                onClick={() => onDetailSelect?.(item.timeseries_id)}
              >
                Details
              </Button>
              <CheckBox
                ariaLabel={`Select ${item.tag_name}`}
                checked={checked}
                disabled={disabled}
                onCheckedChange={value => onCheckedChange?.(item, value)}
              />
            </div>
          </ListItem.Tail>
        </ListItem.BodyTail>
      </ListItem>
    </List.Middle>
  );
};

export const SoftTagListItem = memo(SoftTagListItemComponent);

const SoftTagListItemSkeletonComponent = () => {
  return (
    <List.Middle>
      <ListItem>
        <ListItem.BodyTail divider>
          <ListItem.Body>
            <ListItem.Subtitle>
              <LoaderPlaceholder className="w-[200px]! rounded-lg!" />
            </ListItem.Subtitle>
            <ListItem.Caption>
              <LoaderPlaceholder className="mt-3 rounded-lg!" />
            </ListItem.Caption>
          </ListItem.Body>
          <ListItem.Tail className="items-end! gap-2!">
            <LoaderPlaceholder className="rounded-lg!" />
            <LoaderPlaceholder className="rounded-lg!" />
            <LoaderPlaceholder className="rounded-lg!" />
          </ListItem.Tail>
        </ListItem.BodyTail>
      </ListItem>
    </List.Middle>
  );
};

export const SoftTagListItemSkeleton = memo(SoftTagListItemSkeletonComponent);
